import { render, staticRenderFns } from "./FullscreenStep.vue?vue&type=template&id=df868f54"
import script from "./FullscreenStep.vue?vue&type=script&lang=js"
export * from "./FullscreenStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports